import { useEffect, useState } from "react";
import { phoneSchemas } from "src/main/components/validation/loginSchema";
import { DEV_TOOL } from "src/main/contants";
import { DeployCountry } from "src/main/types";
import { getDeployEnv } from "src/main/utils";

const currentEnv = getDeployEnv();

const useCountryValidationSchema = () => {
  const [phoneValSchema, setPhoneValSchema] = useState(phoneSchemas[currentEnv.deployCountry]);

  useEffect(() => {
    // get deploy country from session storage
    const deployCountry = sessionStorage.getItem(DEV_TOOL.SESSION_STORAGE.LOGIN_COUNTRY);
    if (deployCountry) {
      setPhoneValSchema(phoneSchemas[deployCountry as DeployCountry]);
    }
  }, []);

  return {
    phoneValSchema,
  };
};

export default useCountryValidationSchema;
